import { Link } from 'react-router-dom'
import { ShoppingCart, Eye, Leaf } from 'lucide-react'
import { getImageUrl } from '../utils/imageHelper'

const ProductCard = ({ product, onProductClick }) => {
  const { id, name, image, shortDesc, npk, price, sizes, category, slug } = product

  const handleBuyClick = (e) => {
    e.preventDefault()
    // Mock buy functionality - in a real app, this would add to cart
    alert(`Added ${name} to cart! (This is a demo)`)
  }

  const handleCardClick = () => {
    console.log(image)
    if (onProductClick) {
      onProductClick(product)
    }
  }

  return (
    <div
      className="card group hover:scale-105 transition-transform duration-300 cursor-pointer"
      onClick={handleCardClick}
    >
      {/* Product Image */}
      <div className="relative overflow-hidden">
        <img
          src={getImageUrl(image)}
          alt={name}
          className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-earth-green text-white px-3 py-1 rounded-full text-sm font-medium capitalize">
            {category}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <div className="bg-white bg-opacity-90 p-2 rounded-full">
            <Leaf className="h-5 w-5 text-earth-green" />
          </div>
        </div>
      </div>

      {/* Product Info */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-earth-green transition-colors">
          {name}
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-2">{shortDesc}</p>
      </div>
    </div>
  )
}

export default ProductCard
